/** Dominican cédula check digit (same weights as ValidDominicanCedula on the API). */
export function isValidDominicanCedula(value: string): boolean {
  const cleaned = value.replace(/[- .]/g, '');
  if (!/^\d{11}$/.test(cleaned)) return false;

  const digits = cleaned.split('').map((d) => Number(d));
  const weights = [1, 2, 1, 2, 1, 2, 1, 2, 1, 2];
  let sum = 0;
  for (let i = 0; i < 10; i += 1) {
    let product = digits[i] * weights[i];
    if (product > 9) product -= 9;
    sum += product;
  }
  const checkDigit = (10 - (sum % 10)) % 10;
  return checkDigit === digits[10];
}
